import { render, staticRenderFns } from "./indexAgent.vue?vue&type=template&id=68b930e4"
import script from "./indexAgent.vue?vue&type=script&lang=js"
export * from "./indexAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports